// Menu store module
const state = {
    menuItems: [
        {
            title: "AGENDA",
            icon: "mdi-calendar-month",
            route: { name: "schedule" }
        },
        {
            title: "CHECKOUT",
            icon: "mdi-cash-fast",
            route: { name: "checkout" }
        },
        {
            title: "CLIENTES",
            icon: "mdi-account-box-multiple",
            route: { name: "persons" }
        },
        {
            divider: true
        },
        {
            title: "SERVIÇOS",
            icon: "mdi-chair-rolling",
            route: { name: "services" }
        },
        {
            title: "BEAUTY MAKERS",
            icon: "mdi-hair-dryer-outline",
            route: { name: "bms" }
        },
        {
            title: "FORNECEDORES",
            icon: "mdi-factory",
            route: { name: "suppliers" }
        },
        {
            title: "PRODUTOS",
            icon: "mdi-shopping",
            route: { name: "products" }
        },
        {
            divider: true
        },
        {
            title: "PERFIL",
            icon: "mdi-account-box",
            route: { name: "profile" }
        },
        {
            title: "BANNERS",
            icon: "mdi-camera-image",
            route: { name: "profileBanners" }
        },
        {
            title: "LYNDUS PASS",
            icon: "mdi-file-sign",
            route: { name: "lynduspass" },
            requiresWhitelist: true
        },
        {
            title: "RELATÓRIOS",
            icon: "mdi-file-chart",
            route: { name: "reports" },
            requiresWhitelist: true
        },
        {
            title: "FINANCEIRO",
            icon: "mdi-currency-usd",
            expanded: true,
            children: [
                {
                    title: "FATURAMENTO",
                    icon: "mdi-cash-register",
                    route: { name: "invoices" }
                },
                {
                    title: "CAIXA",
                    icon: "mdi-cash-register",
                    route: { name: "cashFlow" }
                },
                {
                    title: "COBRANÇAS",
                    icon: "mdi-view-list-outline",
                    route: { name: "charges" }
                },
                {
                    title: "CONTAS",
                    icon: "mdi-bank",
                    route: { name: "financialAccounts", params: { } }
                },
                {
                    title: "LYNDUS PAY",
                    icon: "mdi-hand-coin",
                    route: { name: "receivements" }
                }
            ]
        },
        {
            title: "USUÁRIOS",
            icon: "mdi-account-group",
            route: { name: "users" }
        },
        {
            divider: true
        },
        {
            title: "SAIR",
            icon: "mdi-logout",
            route: { name: "logout" }
        }
    ]
};

const getters = {
    getMenuItems: (state) => state.menuItems,
    getFilteredMenuItems: (state, getters, rootState, rootGetters) => {
        const currentUser = rootGetters.currentUser;
        const whitelistedUsers = ['PRZYBYSZEWSKI', 'ADVENTUS', 'EDLINGE', 'GRANDI','GERSON'];
        const isWhitelisted = currentUser && whitelistedUsers.some(allowed => currentUser.includes(allowed));
        
        console.log("currentUser", currentUser);
        console.log(isWhitelisted);
        
        return state.menuItems.filter(item => {
            if (item.requiresWhitelist && !isWhitelisted) {
                return false;
            }
            return true;
        });
    }
};

export default {
    state,
    getters
}; 